import store from "@/store";
import router from "@/router";
import {Message, MessageBox} from 'element-ui'
import {Dialog, Toast} from 'vant';
import MD5 from 'js-md5'

export const TOAST = {
    success: 'success',
    error: 'error'
}

export const loading = (msg = '正在加载...') => {
    Toast.loading({message: msg, forbidClick: true, duration: 0});
}
export const loaded = () => {
    Toast.clear()
}

export const toast = (msg, type = TOAST.success) => {
    if (browserRedirect() === 1) {
        Toast(msg)
    } else {
        if (type === TOAST.success) {
            Message.success({message: msg, duration: 2500})
        } else {
            Message.error({message: msg, duration: 2500})
        }
    }
}

export const confirm = (title, msg, fn, confirmButtonText = '确认', showCancelButton = false, cancel = () => {
},cancelButtonText = '取消') => {
    if (browserRedirect() === 1) {
        Dialog.confirm({
            title: title,
            message: msg,
            confirmButtonText: confirmButtonText,
            showCancelButton: showCancelButton,
        }).then(() => {
            fn()
        }).catch(() => {
            cancel()
        })
    } else {
        MessageBox.confirm(
            msg, title, {
                confirmButtonText: confirmButtonText,
                cancelButtonText: cancelButtonText,
                type: 'warning',
                showClose: false,
                showCancelButton: showCancelButton,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                dangerouslyUseHTMLString:true
            }
        ).then(() => {
            fn()
        }).catch(() => {
            cancel()
        })
    }
}


export const loginTimeOut = () => {
    confirm('系统提示', '登录状态已过期，请您重新登录', logout, '重新登录')
}

export const userLogout = () => {
    confirm('退出登录', '你确定退出当前帐号吗？', logout, '退出', true)
}

export const logout = () => {
    window.localStorage.removeItem('user')
    window.localStorage.removeItem('token')
    window.localStorage.removeItem('php_token')
    store.dispatch('LogOut').then(() => {
        router.replace('/login')
    })
}

export const md5 = (str) => {
    return MD5(str).substr(8, 16).toUpperCase()
}

/**
 * 获取Token
 */
export const getToken = () => {
    let user = JSON.parse(window.localStorage.getItem('user'))
    return user ? {token: user.token,mid:user.mid} : {}
}

/**
 * 获取季度
 */
export const getQuarters = (start = 2019) => {
    let quarters = []
    let date = new Date();
    let fullYear = date.getFullYear();
    let month = date.getMonth() + 1 ;
    for (let year = fullYear; year > start; year--) {
        let quarter = fullYear === year ? parseInt((month % 3 === 0 ? month / 3 : month / 3 + 1)) : 4
        for (let q = quarter; q > 0; q--) {
            quarters.push({
                year: year,
                quarter: q
            })
        }
    }
    return quarters
}

/**
 * 获取季度
 */
export const getQuarter = () => {
    let date = new Date();
    let month = date.getMonth() + 1;
    return parseInt(month % 3 === 0 ? month / 3 : month / 3 + 1)
}

/**
 * 获取季度
 */
export const getQuarterDate = (quarter,end = false) => {
    switch (Number(quarter)) {
        case   1:
            return end ? '3月31日' : '1月1日'
        case   2:
            return  end ? '6月31日' : '4月1日'
        case   3:
            return  end ? '9月31日' : '7月1日'
        default :
            return  end ? '12月31日' : '8月1日'
    }
}

/**
 * 获取季度名字
 */
export const getQuarterName = (quarter) => {
    switch (Number(quarter)) {
        case   1:
            return '一'
        case   2:
            return '二'
        case   3:
            return '三'
        default :
            return '四'
    }
}


export const getYears = (start = 2020) => {
    let years = []
    let date = new Date();
    let fullYear = date.getFullYear();
    for (let year = fullYear; year > start; year--) {
        years.push({
            year: year
        })
    }
    return years
}

const wxsdk = require('jweixin-module')
export const shareWx = (data, _title, _url, _image, _summary) => {
    wxsdk.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.appId, // 必填，公众号的唯一标识
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature.toLowerCase(), // 必填，签名，见附录1
        jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"]
    });
    wxsdk.ready(function () {
        //获取“分享给朋友”按钮点击状态及自定义分享内容接口(即将废弃)
        wxsdk.updateAppMessageShareData({
            title: _title, // 分享标题
            desc: _summary, // 分享描述
            link: _url, // 分享链接
            imgUrl: _image, // 分享图标
            success: function () {
                // 用户确认分享后执行的回调函数
            },
            cancel: function () {
                // 用户取消分享后执行的回调函数
            }
        });

        //获取“分享到朋友圈”按钮点击状态及自定义分享内容接口(即将废弃)
        wxsdk.updateTimelineShareData({
            title: _title, // 分享标题
            desc: _summary, // 分享描述
            link: _url, // 分享链接
            imgUrl: _image, // 分享图标
            success: function () {
                // 用户确认分享后执行的回调函数
            },
            cancel: function () {
                // 用户取消分享后执行的回调函数
            }
        });
    });
}

/*
* 数据过滤全部
* */
export const formatHtml = (str, replace = '') => {
    const pattern = /<(\S*?)[^>]*>.*?|<.*? > /ig
    return str.replace(pattern, replace).replace(/&nbsp;/ig, "").replace(/&emsp;/ig, "")
}

export const getQueryString = (name) => {
    const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    const r = window.location.search.substr(1).match(reg);
    if (r !== null) return unescape(r[2]);
    return null;
}

/*
* 时间转换
* */
export const zhDate = (date, type) => {
    let now = new Date(date)
    let year = now.getFullYear()
    let month = now.getMonth() + 1
    let day = now.getDate()
    let hour = now.getHours()
    let minute = now.getMinutes()
    let second = now.getSeconds()
    if (type === 1) {
        return year + "-" + getzf(month) + "-" + getzf(day) + "  " + getzf(hour) + ":" + getzf(minute)
    } else if (type === 2) {
        return year + "-" + getzf(month) + "-" + getzf(day) + "  " + getzf(hour) + ":" + getzf(minute) + ":" + getzf(second)
    } else if (type === 3) {
        return getzf(hour) + ":" + getzf(minute)
    } else if (type === 4) {
        return year
    } else if (type === 5) {
        return year + "-" + getzf(month)
    }  else if (type === 6) {
        return getzf(month) + "/" + getzf(day)
    } else {
        return year + "-" + getzf(month) + "-" + getzf(day)
    }
}

export const getYear = () => {
    let now = new Date()
    return now.getFullYear()
}

export const getMonth = () => {
    let now = new Date()
    return now.getMonth() + 1
}


function getzf(num) {
    if (parseInt(num) < 10) {
        num = '0' + num
    }
    return num
}

export const browserRedirect = () => {   //  1 手机 2 pc
    let sUserAgent = navigator.userAgent.toLowerCase();
    let bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
    let bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
    let bIsMidp = sUserAgent.match(/midp/i) == "midp";
    let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
    let bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
    let bIsAndroid = sUserAgent.match(/android/i) == "android";
    let bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
    let bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
    if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
        return 1
    } else {
        return 2
    }
}

export const _isMobile = () => {   //  1 手机 2 pc
    return browserRedirect() === 1
}

/**
 * form表单验证 提示错误信息 跳转到第一条错误的位置
 * @param validates this.$refs[formName].validate((valid, validates) => {
          if (valid) {
              this.submitChange()
          } else {
              scrollIntoView(this, validates)
          }
      });
 */
export const scrollIntoView = (_this, validates) => {
    let error = Object.values(validates).shift().shift()
    let refs = _this.$refs[error.field.split('.').join('')]
    let dom = refs instanceof Array ? refs[0] : refs
    _this.$confirm(error.message, "提示", {
        confirmButtonText: "确定",
        showCancelButton: false,
        type: "warning",
    }).then(() => {
        dom.$el.scrollIntoView({
            block: 'center', // 当前元素显示在视图区域中间
            behavior: 'auto' // 滚动速度
        })
    })
}

export const setPath = (chinese, url) => {
    return {
        chinese,
        url
    }
}

/**
 * 数据过滤全部
 * @param {*} index
 * @param {*} arr
 * @returns
 */
export const slice = (arr, index = 1) => {
    return arr.slice(index)
}
export const splice = (arr, index = 1) => {
    return arr.splice(index)
}

export const getCharCount = (str, char ) => {
    //得到字符串含有某个字符的个数
    const regex = new RegExp(char, 'g'); // 使用g表示整个字符串都要匹配
    const result = str.match(regex);          //match方法可在字符串内检索指定的值，或找到一个或多个正则表达式的匹配。
    return !result ? 0 : result.length;
}

/**
 * 动态加载百度地图api函数
 * @param {String} ak  百度地图AK，必传
 */
export const loadBMap=(ak)=> {
    return new Promise(function (resolve, reject) {
        if (typeof window.BMap !== 'undefined') {
            resolve(window.BMap)
            return true
        }
        window.onBMapCallback = function () {
            resolve(window.BMap)
        }
        let script = document.createElement('script')
        script.type = 'text/javascript'
        script.src = 'https://api.map.baidu.com/api?v=3.0&ak=' + ak + '&callback=onBMapCallback'
        script.onerror = reject
        document.head.appendChild(script)
    })
}

export const wxOauth2Url = () => {
    return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa8ead9bb1a039de5&redirect_uri=${location.origin}${location.pathname}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
    // return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa8ead9bb1a039de5&redirect_uri=http://lkz.data.shzzpt.org.cn&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`
    // return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa8ead9bb1a039de5&redirect_uri=http://lkz.data.shzzpt.org.cn&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
}

export const downloadFile = (data,fileName) =>{
    let url = window.URL.createObjectURL(new Blob([data]));
    let link = document.createElement('a');
    link.style.display = 'none';
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
}

/**
 * 数字金额转汉字金额
 * val为字符串类型
 */
export const formatMoneyCN = (val) => {
    //汉字的数字
    const cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
    //基本单位
    const cnIntRadice = ['', '拾', '佰', '仟'];
    //对应整数部分扩展单位
    const cnIntUnits = ['', '万', '亿', '兆'];
    //对应小数部分单位
    const cnDecUnits = ['角', '分', '毫', '厘'];
    //整数金额时后面跟的字符
    const cnInteger = '整';
    //整型完以后的单位
    const cnIntLast = '元';
    //最大处理的数字
    const maxNum = 999999999999999.9999;
    //金额整数部分
    let integerNum;
    //金额小数部分
    let decimalNum;
    //输出的中文金额字符串
    let chineseStr = '';
    //分离金额后用的数组，预定义
    let parts;
    if (val === '') return ''
    val = parseFloat(val);
    //超出最大处理数字
    if (val >= maxNum) return ''

    if (val === 0) {
        chineseStr = cnNums[0] + cnIntLast + cnInteger;
        return chineseStr;
    }
    //转换为字符串
    val = val.toString();
    if (val.indexOf('.') === -1) {
        integerNum = val;
        decimalNum = '';
    } else {
        parts = val.split('.');
        integerNum = parts[0];
        decimalNum = parts[1].substr(0, 4);
    }
    //获取整型部分转换
    if (parseInt(integerNum, 10) > 0) {
        let zeroCount = 0;
        let IntLen = integerNum.length;
        for (let i = 0; i < IntLen; i++) {
            let n = integerNum.substr(i, 1);
            let p = IntLen - i - 1;
            let q = p / 4;
            let m = p % 4;
            if (n === '0') {
                zeroCount++;
            } else {
                if (zeroCount > 0) {
                    chineseStr += cnNums[0];
                }
                //归零
                zeroCount = 0;
                chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
            }
            if (m === 0 && zeroCount < 4) {
                chineseStr += cnIntUnits[q];
            }
        }
        chineseStr += cnIntLast;
    }
    //小数部分
    if (decimalNum !== '') {
        let decLen = decimalNum.length;
        for (var i = 0; i < decLen; i++) {
            let n = decimalNum.substr(i, 1);
            if (n !== '0') {
                chineseStr += cnNums[Number(n)] + cnDecUnits[i];
            }
        }
    }
    if (chineseStr === '') {
        chineseStr += cnNums[0] + cnIntLast + cnInteger;
    } else if (decimalNum === '') {
        chineseStr += cnInteger;
    }
    return chineseStr;
}